export const infiniteScrollListContainerStyles =
   'max-w-[816px] mx-auto flex flex-col-reverse flex-1 w-full min-h-0 overflow-y-auto hidden-scrollbar px-[20px]'

export const infiniteScrollListInnerContainerStyles =
   'flex flex-col items-start justify-start pt-6 '
